import AnalyticsHandler from './AnalyticsHandler';

export default AnalyticsHandler;
